import { useState } from "react";
import { toast } from "sonner";
import { Flag } from "lucide-react";
import { api, formatApiError } from "@/lib/api";

export const ReportButton = ({ kind, itemId, scopeId, id }) => {
  const [done, setDone] = useState(false);
  const report = async () => {
    const reason = window.prompt("Why are you reporting this? (optional)");
    if (reason === null) return;
    try { await api.post("/reports", { kind, item_id: itemId, scope_id: scopeId, reason }); setDone(true); toast.success("Reported. An admin will review it"); }
    catch (e) { toast.error(formatApiError(e)); }
  };
  return (
    <button type="button" data-testid={id || `report-${itemId}`} onClick={report} disabled={done} aria-label="Report"
      className={`inline-flex items-center gap-1 text-[11px] font-semibold ${done ? "text-slate-400" : "text-slate-500 hover:text-rose-700"}`}>
      <Flag className="w-3 h-3" />{done ? "Reported" : "Report"}
    </button>
  );
};
